import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Button, Card, CardBody, CardHeader} from "reactstrap";
import {Field, reduxForm} from 'redux-form';

import {handleChangePassword} from "./actions/settings";

import {InputField} from "../../validation/ReduxFormInput";

class ChangePassword extends Component {
    render() {
        const {handleSubmit, _handleChangePassword, pristine, submitting, invalid} = this.props;
        return (
            <Card className="pr-card">
                <CardHeader tag="h4">Change Your Password</CardHeader>
                <CardBody>
                    <form onSubmit={handleSubmit(_handleChangePassword)}>
                        <Field name="password" label="New Password" component={InputField} type="password"/>
                        <Field name="repeated_password" label="Confirm New Password" component={InputField} type="password"/>
                        <Button color="success" type="submit" disabled={pristine || submitting || invalid}>Update Password</Button>
                    </form>
                </CardBody>
            </Card>
        );
    }
}

const validate = (values) => {
    const errors = {};

    !values.password && (errors.password = 'Required');
    !values.repeated_password && (errors.repeated_password = 'Required');

    (values.password && values.password.length < 8) && (errors.password = 'Must be at least 8 characters!');

    (values.password !== values.repeated_password) && (errors.repeated_password = 'Passwords do not match!');

    return errors;
};

ChangePassword = reduxForm({
    form: 'settings_password',
    validate
})(ChangePassword);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    _handleChangePassword(data) {
        return dispatch(handleChangePassword(data));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);


// WEBPACK FOOTER //
// ./src/containers/settings/ChangePassword.js